import { ColorPickerColors } from '../../../ColorPicker/logic'
import { hexToRgb } from './hexToRgb'

export const getPickerColor = (colorClassName: string): string | null => {
  const pickerColor = ColorPickerColors.find(({ className }) => className === colorClassName)

  if (pickerColor) {
    return pickerColor.color
  }

  return null
};

export const getPickerHexColor = (colorClassName: string): {r: number; g: number; b: number} | null => {
  const pickerColor = ColorPickerColors.find(({ className }) => className === colorClassName)

  if (pickerColor) {
    return hexToRgb(pickerColor.color)
  }
  return null
}
